module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('Password Reset')))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_vm._v(" ")]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "box login-box text-center"
  }, [_c('p'), _c('div', [_vm._v(_vm._s(_vm.$t('forgot_password.input_email')))]), _c('div', [_vm._v(_vm._s(_vm.$t('forgot_password.send_reset_email')))]), _c('p'), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }, [_vm._v(_vm._s(_vm.$t('Mail Address')))]), _c('div', {
    staticClass: "col-sm-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "name": "email",
      "required": "required"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.canSubmit(),
      "type": "button"
    },
    on: {
      "click": _vm.sendMail
    }
  }, [_vm._v(_vm._s(_vm.$t('Send')))])]), _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('forgot_password.back_to_login')) + " ")]), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Login')))])])], 1), (_vm.showMessage) ? _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "alert",
    class: {
      'alert-success': _vm.isForgotPasswordSuccess, 'alert-danger': !_vm.isForgotPasswordSuccess
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message))])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-642f2734!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/forgot-password.pug
// module id = 827
// module chunks = 1